import React from 'react';
import MotionContainer from '../components/Motion/MotionContainer';
import Section from '../components/Section/Section';
import SkillContent from '../components/SkillContent/SkillContent';

const Skills = () => {
  return (
    <MotionContainer>
      <Section title="Skill">
        <SkillContent />
      </Section>
    </MotionContainer>
  );
};

export default Skills;
